import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'sirius-checkmark',
    template: `<sirius-icon [name]="'check'" [attr.aria-hidden]="true"></sirius-icon>{{ resolvedLabel() }}`,
    styleUrls: ['./checkmark.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'sir-text-style-paragraph-m-default' },
    imports: [IconComponent],
})
export class CheckmarkComponent {
    readonly config = input<string>();
    readonly label = input('');

    protected readonly resolvedLabel = computed(() => this.config() ?? this.label());
}
